import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { injectIntl } from 'react-intl';
import { complement, compose, either, isEmpty, isNil } from 'ramda';

import { Field, Container, ErrorText, Label } from './input.styles';
import { renderWhenNotNil, renderWhenTrue } from '../../utils/rendering';

export class InputComponent extends PureComponent {
  static propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.object,
    intl: PropTypes.object,
    containerStyles: PropTypes.any,
    touched: PropTypes.bool,
    light: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  get hasValueDefined() {
    return complement(either(isEmpty, isNil))(this.props.value);
  }

  get hasError() {
    return !!this.props.error && this.props.touched;
  }

  renderLabel = renderWhenNotNil(() => <Label>{this.props.label}</Label>);

  renderError = renderWhenTrue(() => <ErrorText>{this.props.intl.formatMessage(this.props.error)}</ErrorText>);

  render() {
    return (
      <ThemeProvider
        theme={{
          disabled: this.props.disabled,
          isLight: this.props.light,
          hasValue: this.hasValueDefined,
          hasError: this.hasError,
        }}
      >
        <Container extraStyles={this.props.containerStyles}>
          {this.renderLabel(this.props.label)}
          <Field {...this.props} />
          {this.renderError(this.hasError)}
        </Container>
      </ThemeProvider>
    );
  }
}

export const Input = compose(injectIntl)(InputComponent);
